import { createHttp } from 'utils/http';

const http = createHttp();

// Actions
export const LOAD_WEATHER_CONDITIONS_START = 'LOAD_WEATHER_CONDITIONS_START';
export const LOAD_WEATHER_CONDITIONS_SUCCESS = 'LOAD_WEATHER_CONDITIONS_SUCCESS';
export const LOAD_WEATHER_CONDITIONS_FAILURE = 'LOAD_WEATHER_CONDITIONS_FAILURE';

// Action Creators
export const loadWeatherConditionsStart = () => ({
    type: LOAD_WEATHER_CONDITIONS_START,
});

export const loadWeatherConditionsSuccess = weatherConditions => ({
    type: LOAD_WEATHER_CONDITIONS_SUCCESS,
    payload: weatherConditions,
});

export const loadWeatherConditionsFailure = error => ({
    type: LOAD_WEATHER_CONDITIONS_FAILURE,
    payload: error,
});

// Async Action
export const loadWeatherConditions = (campaignId, environment = 'ca') => async dispatch => {
    dispatch(loadWeatherConditionsStart());

    try {
        // Updated to use the new ui-options endpoint (no longer requires campaignId)
        const url = `ui-options/weather-conditions?environment=${environment}`;
        const response = await http.get(url);

        // HTTP client returns data directly, not in response.data
        const responseData = response.data || response;

        dispatch(loadWeatherConditionsSuccess(responseData));
    } catch (error) {
        console.error('Failed to load weather conditions:', error);
        dispatch(loadWeatherConditionsFailure(error));
    }
};
